import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import "aos/dist/aos.css";


const Nav = styled.nav`
    display: block;
    border-bottom: 1px solid black;
    background-color: white;
    background-size: cover;
    @media (min-width: 768px) {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 3rem;
  }
`;

const Title = styled.p`
    color: black;
    text-decoration: underline white;
    font-size: 1rem;

    padding: 1rem;
    @media (min-width: 768px) {
    font-size: 1.5rem;

    }
`;

const Span = styled.p`
    color: black;
    margin-left: 2.5rem;
    text-decoration: underline white;
    font-size: 2rem;
    padding: .5rem;
    @media (min-width: 768px) {
    font-size: 3.1rem;
    margin-left: 0;
    }
`;
const Preg = styled.p`
   display: inline;
    @media (min-width: 768px) {
      display: flex;
    }
`;
const Header = () => {
  return (
    <Nav>
      <div data-aos="fade-down">
          <Link to={'/'}>
        <Span>Ilustraciones Sofia</Span>
      </Link>
      </div>
    </Nav>
  );
}

export default Header;